<template>
  <div class="partTime">
    <el-tabs v-model="status" @tab-click="changeTab">
      <el-tab-pane label="候选人报名" name="9"></el-tab-pane>
      <el-tab-pane label="新推荐" name="1"></el-tab-pane>
      <el-tab-pane label="已录取" name="2"></el-tab-pane>
      <el-tab-pane label="已到岗" name="3,4"></el-tab-pane>
      <el-tab-pane label="已完成" name="5"></el-tab-pane>
      <el-tab-pane label="已终止" name="6,7,8,11"></el-tab-pane>
    </el-tabs>
    <el-row :gutter="20" style="margin-bottom: 35px">
      <el-col :span="6">
        <el-input
          placeholder="请输入关键ID"
          v-model="params.job_company_id"
        ></el-input>
      </el-col>
      <el-col :span="18" style="display: flex;align-items: center;">
        <span class="deliver_types">投递方式</span>
        <a-select default-value="post_type" v-model="post_type" style="width: 120px;margin-right: 10px;" @change="changeDeliverType">
          <a-select-option value="">
            全部
          </a-select-option>
          <a-select-option value="1">
            猎头推荐
          </a-select-option>
          <a-select-option value="2">
            候选人报名
          </a-select-option>
        </a-select>
        <el-button type="primary" size="medium" @click="getData()"
          >搜索</el-button
        >
        <el-button size="medium" @click="reset()">重置</el-button>
      </el-col>
    </el-row>
    <div class="job-list" v-loading="loading">
      <el-card
        class="job-item"
        v-for="(item, index) in list"
        :key="index"
        shadow="hover"
        @click.native="showDrawer(item)"
      >
        <el-row type="flex" justify="space-between">
          <el-col class="left">
            <span @click.stop
              ><el-checkbox
                v-model="item.isSelected"
                @change="handleSelect"
                v-if="status == 1"
            /></span>
            <div class="info">
              <div class="info_type_tag" :class="item.source != 'columbus_mini_app' ? 'blue' : 'green'">{{item.source != 'columbus_mini_app' ? '猎头岗位' : '候选人报名'}}</div>
              <img
                class="avatar"
                :src="item.resume.photo_url || default_avatar"
              />
              <div style="margin-top: 10px">
                <p>
                  <span class="name">{{ item.resume.name }}</span>
                  <span class="">报名兼职</span>
                  <span style="color: #1989ff">{{ item.job_name }}</span>
                </p>
                <p>
                  {{ item.resume.gender_id == 1 ? "男" : "女" }}
                  {{ item.resume.age }}岁 {{ item.resume_mobile }}
                  {{ item.resume.school_graduated }}
                </p>
                <p class="leave-word">留言：{{ item.suggestion }}</p>
              </div>
            </div>
          </el-col>
          <el-col class="salary" v-if="status != 1 && item.employ">
            <p>
              薪资：{{ item.employ.basic_salary_lower }}-{{
                item.employ.basic_salary_upper
              }}元 / {{ item.employ.basic_salary_period | basicSalaryPeriod }}
            </p>
            <p>
              提成：{{ item.employ.bonus_value
              }}{{
                item.employ.bonus_type === 2
                  ? "%"
                  : item.employ.bonus_type === 3
                  ? "元/件"
                  : ""
              }}
            </p>
            <p>预计入职：{{ item.employ.on_board_time }}</p>
          </el-col>
          <el-col class="center" v-if="item.user">
            <img class="avatar" :src="item.resume.picture || default_avatar" />
            <div style="margin-top: 10px">
              <p>{{ item.user.name }}</p>
              <p class="phone">{{ item.user.tel }}</p>
            </div>
          </el-col>
          <el-col class="right" :span="6">
            <div
              class="warning"
              @click.stop="$refs.complainDialog.open(item.id)"
            >
              <i class="el-icon-warning-outline" title="投诉"></i>
            </div>
          </el-col>
        </el-row>
        <el-row class="sign-date" type="flex" justify="space-between">
          <el-col
            style="line-height: 36px"
            @click.native.stop="showProcess(item)"
            >{{ item.created_at }} 报名 <i class="el-icon-arrow-down"></i
          ></el-col>
          <el-col style="text-align: right">
            <el-button
              size="medium"
              icon="el-icon-phone"
              @click.stop="openChat(item)"
              >{{ item.user ? "联系猎头" : "联系人选" }}</el-button
            >
            <template v-if="status == 9">
              <el-button
                icon="el-icon-circle-close"
                size="medium"
                type="primary"
                @click.native.stop="handleRecommend(item)"
                >推荐</el-button
              >
              <el-button
                icon="el-icon-circle-close"
                size="medium"
                type="danger"
                @click.native.stop="handleRejected(item)"
                >拒绝</el-button
              >
            </template>
            <template>
              <el-button
                icon="el-icon-circle-check"
                size="medium"
                type="primary"
                @click.native.stop="$refs.offerDialog.open(item, '录用')"
                v-if="status == 1"
                >录用</el-button
              >
              <el-button
                icon="el-icon-circle-check"
                size="medium"
                type="primary"
                @click.native.stop="$refs.offerDialog.open(item, '到岗')"
                v-else-if="status == 2"
                >已到岗</el-button
              >
            </template>
            <template v-if="status == 2">
              <el-button
                icon="el-icon-circle-close"
                size="medium"
                type="danger"
                @click.native.stop="cancelOffer(item.id)"
                >取消录用</el-button
              >
            </template>
            <template v-if="status == '3,4'">
              <el-button
                type="primary"
                size="medium"
                @click.stop="topay(item, 'salary')"
                >支付工资</el-button
              >
              <!-- <el-button size="medium" plain @click.stop="topay(item, 'service_fee')">支付服务费</el-button> -->
              <el-dropdown
                class="btn-item"
                style="margin-left: 10px"
                @click.stop.native="
                  () => {
                    return false;
                  }
                "
              >
                <el-button size="medium" type="primary" plain
                  >更多<i class="el-icon-arrow-down el-icon--right"></i
                ></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="cancelOffer(item.id)">
                    取消录用
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="finishJob(item)">
                    工作结束
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template v-else-if="status == 1 || status == 2 || status == 3">
              <el-button
                icon="el-icon-circle-close"
                size="medium"
                type="danger"
                @click.native.stop="giveUp(item)"
                >{{status == 1 ? '拒绝' : '放弃'}}</el-button
              >
            </template>
          </el-col>
        </el-row>
      </el-card>
      <!-- <Empty v-if="!list.length"></Empty> -->
    </div>
    <Pagination ref="pagination" :total="total" @change="getData" />
    <el-drawer :visible.sync="drawer" :with-header="false" size="800px">
      <el-row
        type="flex"
        justify="space-between"
        align="center"
        style="paddingbottom: 40px"
      >
        <el-col style="cursor: pointer" @click.native="drawer = false">
          <i class="el-icon-close"></i>
        </el-col>
        <el-col
          style="cursor: pointer; text-align: right"
          @click.native="toDetail"
        >
          <i class="el-icon-rank"></i>在新窗口打开
        </el-col>
      </el-row>
      <component
        v-if="drawer"
        :is="currentTabComponent"
        :id="id"
        :ref="currentTabComponent == 'PartTimeExamine' ? 'partTimeExamines' :''"
        @recommend="handleRecommend"
        @rejected="handleRejected"
        @employment="handleEmployment"
        @haveArrived="handleHaveArrived"
        @giveUp="handleGiveUp"
        @payWages="handlePayWages"
        @cancelEmployment="handleCancelEmployment"
        @completion="handleCompletion"
      ></component>
      <!-- <PartTimeDetail :id="id" v-if="isDetail == 1 && drawer"></PartTimeDetail>
      <part-time-examine v-if="isDetail == 2 && drawer" ></part-time-examine> -->
    </el-drawer>
    <el-dialog title="批量支付" :visible.sync="showDialog" width="30%">
      <span style="margin-right: 20px">选择职位</span>
      <el-select v-model="payJob" placeholder="请选择">
        <el-option
          v-for="item in jobList"
          :key="item.job_id"
          :label="item.job_name"
          :value="item.job_id"
        >
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmPay">确 定</el-button>
      </span>
    </el-dialog>
    <PartTimeOfferDialog
      ref="offerDialog"
      :callback="reloadData"
    ></PartTimeOfferDialog>
    <ComplainDialog ref="complainDialog" :callback="reloadData"></ComplainDialog>

    <ProcessDialog ref="processDialog"></ProcessDialog>
    <PayDialog ref="payDialog" :callback="reloadData"></PayDialog>
    <CancelOffer ref="cancelOfferDialog" :callback="reloadData"></CancelOffer>
    <Chat ref="chat"></Chat>
  </div>
</template>
<script>
import PartTimeOfferDialog from "./components/dialogs/partTimeOfferDialog";
import ComplainDialog from "./components/dialogs/complainDialog";
import CancelOffer from "./components/dialogs/cancelOffer";
import ProcessDialog from "./components/dialogs/processDialog";
import PayDialog from "./components/dialogs/payDialog";
import PartTimeExamine from "./part-time-examine";//灵活用工详情
import PartTimeDetail from "./components/partTimeDetail";
import Pagination from "@/components/Pagination";
// import { Base64 } from "js-base64";
import Api from "@/api";
import Chat from "@/app/admin/system/im/c2c/index.vue";

import "@/shared/plugins/element"

export default {
  // name: "PartTime",
  components: {
    Pagination,
    Chat,
    PartTimeDetail,
    PartTimeExamine,
    PartTimeOfferDialog,
    ComplainDialog,
    ProcessDialog,
    CancelOffer,
    PayDialog,
  },
  // inject: ["showIM"],
  data() {
    return {
      default_avatar: require("./images/default_avatar.png"),
      payJob: "",
      showDialog: false,
      drawer: false,
      company: {},
      loading: false,
      visible: false,
      close_reason: "",
      status: "9",
      params: {
        page: 1,
        limit: 10,
        keyword: "",
        job_company_id: "",
      },
      allChecked: false,
      list: [],
      jobList: [],
      total: 0,
      id: "",
      seletedData: [],
      balance: 0, // 账户余额
      statusCounts: {},
      isDetail:1,//灵工详情
      currentTabComponent:'',
      detailId:'',//灵工详情id
      rejectReason:'',//灵工拒绝理由
      post_type:'',//投递状态 1：猎头推荐 2:候选人报名
    };
  },
  mounted() {
    // this.company = JSON.parse(sessionStorage.getItem('company')) || this.$store.state.company
    // if(this.$route.query.status) {
    // 	this.status = this.$route.query.status
    // }
    this.pagination = this.$refs.pagination;
    this.getData();
  },
  methods: {
    showDrawer(item) {
      this.drawer = true;
      this.id = item.id;
      let type;
      item.source == 'columbus_mini_app' ? type = 2 : type = 1; 
      this.$nextTick(()=>{
        type == 1 ? this.currentTabComponent = 'PartTimeDetail' : this.currentTabComponent = 'PartTimeExamine';
      })
    },
    //组件回调重新渲染
    reloadData(){
      this.getData();
      if(this.detailId != ''){
        this.getPartTimeDetail(this.detailId)
      }
    },
    toDetail() {
      // this.drawer = false;
      let resolveRoute = this.$router.resolve({
        path: `/resumeManage/partTime-detail?post_id=${this.id}`,
      });
      window.open(resolveRoute.href, "_blank");
    },
    changeTab() {
      console.log("888");
      this.getData();
    },
    changeDeliverType(){
      this.getData();
    },
    async getData(pager) {
      this.loading = true;
      if (pager) {
        this.params.page = pager.current;
        this.params.limit = pager.pageSize;
      }
      let params = {
        ...this.params,
        // job_company_id: this.company.id,
        status: this.status,
        job_company_id: this.params.job_company_id,
        post_type:this.post_type
      };
      try {
        let res = await Api.post.partTimeOrderList(params);
        console.log(res);
        res.list.forEach((item) => {
          item.isSelected = false;
        });
        this.list = res.list;
        this.total = res.total;
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    showProcess(item) {
      this.$refs.processDialog.open(item);
    },
    // offerMultify() {
    //   if (!this.seletedData.length) {
    //     this.$message.warning("请选择录用人员");
    //     return false;
    //   }
    //   this.$refs.offerDialog.open(this.seletedData, "录用");
    // },
    cancelOffer(id) {
      this.$refs.cancelOfferDialog.open(id);
    },
    complain() {
      this.$refs.complainDialog.open();
    },
    // selectAll(val) {
    //   this.list.forEach((x) => {
    //     x.isSelected = val;
    //   });
    //   this.seletedData = this.list;
    // },
    handleSelect(val) {
      let filter = this.list.filter((x) => {
        return !x.isSelected;
      });
      this.seletedData = this.list.filter((x) => {
        return x.isSelected;
      });
      if (filter.length) {
        this.allChecked = false;
      } else {
        this.allChecked = true;
      }
    },
    reset() {
      this.params = {
        page: 1,
        limit: 10,
        keyword: "",
        job_company_id: "",
        post_type:'',
      };
      this.getData();
    },
    //推荐
    handleRecommend(data){
      this.detailId = data.id;
      this.$msgbox({
        title: "确认将报名人员推荐给企业吗？",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(async ({ value }) => {
        let obj = {
            ids:data.id,
            user_id:data.user_id
          }
       Api.order.columbusRecommend({
         url:`/post/signPass`,
         method:'post',
         body :JSON.stringify(obj)
       }).then(res => {
         console.log(res,1111)
          if (res.code == "OK") {
            this.$message.success("操作成功");
            this.getData();
            if(this.detailId != ''){
              this.getPartTimeDetail(this.detailId)
            }
            this.detailId = '';
          }else{
            this.$message.error("操作失败");
          }
        });
        
      });
    },
    //拒绝
    handleRejected(data){
      this.detailId = data.id;
      this.$msgbox({
        title: "确认将报名人员推荐给企业吗？",
        message: (<textarea vModel={this.rejectReason} style="width:97%;height:90px"></textarea>),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(async ({ value }) => {
        let obj = {
            ids:data.id,
            user_id:data.user_id,
            reason:this.rejectReason
          }
       Api.order.columbusRejected({
         url:`/post/signReject`,
         method:'post',
         body :JSON.stringify(obj)
       }).then(res => {
         console.log(res,1111)
          if (res.code == "OK") {
            this.$message.success("操作成功");
            this.getData();
            this.rejectReason = '';
            if(this.detailId != ''){
              this.getPartTimeDetail(this.detailId)
            }
            this.detailId = '';
          }else{
            this.$message.error("操作失败");
          }
        });
        
      });
    },
    //录用
    handleEmployment(data){
      this.detailId = data.id;
      this.$refs.offerDialog.open(data, '录用')
    },
    //已到岗
    handleHaveArrived(data){
      this.detailId = data.id;
      this.$refs.offerDialog.open(data, '到岗')
    },
    //放弃
    handleGiveUp(data){
      this.detailId = data.id;
      this.giveUp(data)
    },
    //支付工资
    handlePayWages(data){
      this.detailId = data.id;
      this.$refs.payDialog.open(data, 'salary');
    },
    //取消录用
    handleCancelEmployment(data){
      this.detailId = data.id;
      this.$refs.cancelOfferDialog.open(data.id);
    },
    //工作完成
    handleCompletion(data){
      this.detailId = data.id;
      this.finishJob(data)
    },
    getPartTimeDetail(id){
      if(this.$refs.partTimeExamines){
        this.$refs.partTimeExamines.getDetails(id)
      }
    },
    // giveUpMulti() {
    //   if (!this.seletedData.length) {
    //     this.$message.warning("请至少选择一人");
    //     return false;
    //   }
    //   this.$confirm("确认要放弃这些人么?", "提示", {
    //     cancelButtonText: "取消",
    //     confirmButtonText: "确认",
    //     type: "warning",
    //   }).then(async () => {
    //     let arr = [];
    //     this.seletedData.forEach((x) => {
    //       arr.push(x.id);
    //     });
    //     let ids = arr.join(",");
    //     let res = await this.$api.PartTimeApi.reject({ ids });
    //     console.log(res);
    //     if (res) {
    //       this.$message.success("操作成功");
    //       this.getData();
    //     }
    //   });
    // },
    giveUp(record) {
      //  const h = this.$createElement;
      this.$msgbox({
        title: "请输入拒绝原因",
        message: (<textarea vModel={this.close_reason} style="width:97%;height:90px"></textarea>),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(async ({ value }) => {
        /*
        let res = await Api.post.partTimeOrderList(params);
        */
        let res = await Api.post.parTimeDeleteJob({
          ids: record.id,
          reason: this.close_reason,
        });
        if (res) {
          this.$message.success("操作成功");
          this.getData();
          if(this.detailId != ''){
            this.getPartTimeDetail(this.detailId)
          }
          this.close_reason = "";
        }
      });

      // this.$prompt("请输入拒绝原因", "编辑", {
      //   confirmButtonText: "提交",
      //   cancelButtonText: "取消",
      // }).then(async ({ value }) => {

      //   /*
      //   let res = await Api.post.partTimeOrderList(params);
      //   */
      //   let res = await Api.post.parTimeDeleteJob({ ids: record.id, reason: value });
      //   if (res) {
      //     this.$message.success("操作成功");
      //     this.getData();
      //   }
      // });
    },
    finishJob(record) {
      this.$confirm(
        "工作结束后，表示和此员工的工作关系将已完结。请确认要结束吗？",
        "提示",
        {
          cancelButtonText: "取消",
          confirmButtonText: "确认",
          type: "warning",
        }
      ).then(async () => {
        let res = await Api.post.Dismissal({ ids: record.id });
        if (res) {
          this.$message.success("操作成功");
          this.getData();
          if(this.detailId != ''){
            this.getPartTimeDetail(this.detailId)
          }
        }
      });
    },
    async exportList() {
      // let params = {
      //   page: 1,
      //   limit: 9999,
      //   job_company_id: this.company.id,
      //   status: this.status,
      // };
      // let export_data = await this.$api.PartTimeApi.export(params);
      // console.log(export_data);
      // // let analyse_export_data = Base64.decode(export_data);
      // const blob = new Blob([export_data], {
      //   // 定义一个blob
      //   type:
      //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
      // });
      // const downloadElement = document.createElement("a"); // 创建一个标签
      // const href = window.URL.createObjectURL(blob); // 创建a标签的链接
      // downloadElement.style.display = "none";
      // downloadElement.href = href;
      // downloadElement.download = "兼职人员报名记录表.csv"; // 下载之后文档的名字
      // document.body.appendChild(downloadElement); //把a标签加入body中
      // downloadElement.click();
      // document.body.removeChild(downloadElement); // 点击之后移除a标签
      // window.URL.revokeObjectURL(href); // 移除url
    },
    topay(item, type) {
      this.$refs.payDialog.open(item, type);
    },
    async payMulti() {
      console.log(this.company);
      this.showDialog = true;
      let res = await this.$api.PartTimeApi.getJobs(this.company.id);
      this.jobList = res.list;
    },
    confirmPay() {
      if (!this.payJob) {
        this.$message.warning("请选择职位");
        return false;
      }
      this.$router.push({
        path: "/resumeManage/pay",
        query: {
          job_id: this.payJob,
        },
      });
    },
    async openChat(record) {
      if (record.user_id) {
        let { to_account } = await Api.im.createSingle({
          to_user_id: record.user_id,
          to_user_type: "PLATFORM",
        });
        this.$refs.chat.show("C2C" + to_account);
      } else {
        this.$message.info("暂无负责人");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.partTime {
  padding: 20px 40px;
  .deliver_types{
    display: inline-block;
    width: 77px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
  }
  ::v-deep .ant-select-selection--single{
    height: 36px !important;
  }
  ::v-deep .ant-select-selection__rendered{
    line-height: 35px!important;
  }
  .action-bar {
    margin: 40px 0 20px;
  }
  .job-list {
    // max-width: 1200px;
    .job-item {
      position: relative;
      font-size: 14px;
      margin-bottom: 20px;
      cursor: pointer;
      .left {
        display: flex;
        align-items: center;
        .info {
          display: flex;
          .info_type_tag{
            position: absolute;
            top: -20px;
            left: -20px;
            height: 25px;
            line-height: 25px;
            padding-left: 10px;
            padding-right: 10px;
            text-align: center;
            font-size: 12px;
            color: #fff;
          }
          .info_type_tag.green{
            background: #00CC66;
          }
          .info_type_tag.blue{
            background: #0080FF;
          }
          span {
            margin-right: 10px;
          }
          .leave-word {
            font-size: 12px;
            color: #aaa;
          }
        }
      }
      .salary {
        padding-left: 20px;
        padding-top: 10px;
        color: #fc5646;
        border-left: 1px solid #ebeef5;
      }
      .center {
        display: flex;
        // justify-content: center;
      }
      p {
        margin-bottom: 5px;
      }
      .right {
        .btn-item {
          margin: 0 20px;
          cursor: pointer;
          img {
            width: 40px;
            height: 40px;
            margin-bottom: 10px;
          }
        }
        .warning {
          position: absolute;
          font-size: 18px;
          top: -10px;
          right: -10px;
          cursor: pointer;
        }
      }
      .avatar {
        width: 40px;
        height: 40px;
        margin: 10px 15px 0;
      }
      .sign-date {
        margin-top: 15px;
        padding: 15px 30px 0 0;
        border-top: 1px solid #ebeef5;
        font-size: 14px;
        color: #999999;
        cursor: pointer;
      }
    }
  }
}
</style>